import { Alert, AlertDescription, type AlertProps, AlertTitle } from '@glade-ai/ui';
import { WarningDiamond } from '@phosphor-icons/react';
import { type FC } from 'react';

type FieldErrorProps = AlertProps & { description?: string };

const FieldError: FC<FieldErrorProps> = ({ children, description, ...alertProps }) => (
  <Alert valence='error' {...alertProps}>
    <WarningDiamond />
    <AlertTitle>{children}</AlertTitle>
    {description && <AlertDescription>{description}</AlertDescription>}
  </Alert>
);

export default FieldError;
